import { WithStore } from 'pure-react-carousel';
import ImageWatcher, { ImageWatcherProps } from './ImageWatcher';

const ImageWatcherVM = WithStore<ImageWatcherProps>(ImageWatcher);
export default ImageWatcherVM;
